import React, { useEffect, useState } from "react";
import BundleForm from "../../../forms/Bundles";
import { GetProducts } from "../../../services/product";
import useProductsStore from "../../../store/product";

import { CreateBundle as CreateSingleBundle } from "../../../services/bundle";
import { GetCategories } from "../../../services/category";
import { GetBoxes } from "../../../services/box";

const CreateBundle = () => {
  const [categories, setCategories] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const { setProducts } = useProductsStore();
  const [boxes, setBoxes] = useState([]);
  const [productPage, setProductPage] = useState(1);

  const handleSubmit = (bundle) => {
    return CreateSingleBundle(bundle);
  };
  const fetchProducts = async (searchTerm = "") => {
    setIsSearching(true);
    const { data } = await GetProducts(searchTerm, productPage);
    if (data?.result) {
      setProducts(data.result);
    }
    setIsSearching(false);
  };
  const fetchCategories = async () => {
    const { data } = await GetCategories();
    if (data.result) {
      setCategories(data.result);
    }
  };

  const fetchBoxes = async () => {
    const { data } = await GetBoxes();
    if (data.result) {
      setBoxes(data.result);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchCategories();
    fetchBoxes();
  }, [productPage]);
  return (
    <>
      <BundleForm
        searchProduct={fetchProducts}
        onSubmit={handleSubmit}
        key={"create-bundle"}
        bundle={null}
        categories={categories}
        boxes={boxes}
        isSearching={isSearching}
        setIsSearching={setIsSearching}
        productPage={productPage}
        setProductPage={setProductPage}
        heading={"Create bundle"}
        form={"create"}
      />
    </>
  );
};

export default CreateBundle;
